"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var user_1 = tslib_1.__importDefault(require("../user"));
var FileResource = /** @class */ (function (_super) {
    tslib_1.__extends(FileResource, _super);
    function FileResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileResource.endpoint = '/files';
    FileResource.MODEL_NAME = 'file';
    FileResource.related = {
        created_by: user_1.default,
    };
    return FileResource;
}(base_1.default));
exports.default = FileResource;
//# sourceMappingURL=file.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/file.js
// module id = rZNw
// module chunks = 0